import { isEmpty } from 'ramda';
import { RadioInput, RadioInputList } from '@sunwebgroup/ui-components';

import { useFilters, useSelectFilter } from '../../../../domain/hooks';
import { useIntl } from '@/intl';
import FilterGroup from './FilterGroup';
import { createSearchFilterClickEvent } from '../../../../domain/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';

export function TransportTypeFilter() {
  const intl = useIntl();
  const { sendEvent } = useAnalytics();
  const { isFetching, options, selectedValue, setSelection } = useSelectFilter('TransportType');
  const { resetOptionalFilters } = useFilters();

  const handleFilterChange = (value: string) => {
    setSelection(value);
    resetOptionalFilters();
    sendEvent(
      createSearchFilterClickEvent({
        element: 'radio button',
        type: 'transport',
        result: value,
      })
    );
  };

  if (isEmpty(options)) return null;

  return (
    <FilterGroup title={intl.formatMessage({ id: 'transport_type_label' })} defaultOpen>
      <RadioInputList
        label={intl.formatMessage({ id: 'transport_type_options_label' })}
        onValueChange={handleFilterChange}
        defaultValue={selectedValue ?? undefined}
        value={selectedValue}
      >
        {options.map(({ name, value }) => (
          <RadioInput key={value} value={value} label={name} disabled={isFetching} />
        ))}
      </RadioInputList>
    </FilterGroup>
  );
}
